export default __webpack_public_path__ + "static/media/spacegrid.06029af0.jpg";